export enum LoveEvents {
  ConnectedToRoom = 'love.ConnectedToRoom',
  DisconnectedFromRoom = 'love.DisconnectedFromRoom'
}
